import React from 'react';

import { MaskSpan } from './MaskIcon.styles';

export type MaskIconProps = {
  /**
   * SVG URL used as a CSS `mask`. The colour comes from the consumer's CSS
   * (`background-color` on the icon class), NOT from the file — so this only
   * suits monochrome glyphs.
   */
  src: string;
  className?: string;
};

/**
 * Monochrome icon rendered through a CSS `mask-image` — the lean replacement for
 * the old fetch-and-inline approach on single-colour chrome glyphs. The SVG masks
 * a solid box whose colour is `background-color`, so the inactive→active recolour
 * is a plain colour swap in the consumer's stylesheet (`.icon-mask { background-color }`)
 * instead of fetching the file in JS, injecting it via `dangerouslySetInnerHTML`,
 * and rewriting its internal ids. The browser still fetches the mask asset once
 * (natively cached). Decorative → `aria-hidden`. The consumer owns size + colour
 * via the icon class.
 */
export const MaskIcon = ({ src, className }: MaskIconProps): React.ReactElement => (
  <MaskSpan className={className} $src={src} aria-hidden="true" />
);

export default MaskIcon;
